import {
  useMutation,
  useQueryClient,
  queryOptions,
} from "@tanstack/react-query";
import { authenticatedRequest } from "@/lib/graphql/client";
import {
  ADMIN_HANDBOOK_STRUCTURE,
  ADMIN_UPDATE_HANDBOOK_STRUCTURE,
} from "@/lib/graphql/queries/structure";
import type {
  StructureMutationResult,
  StructureResult,
  UpdateStructureInput,
} from "@/types/structure";
import { toast } from "sonner";

export const structureKeys = {
  all: ["handbook-structure"] as const,
};

export function structureQueryOptions() {
  return queryOptions({
    queryKey: structureKeys.all,
    queryFn: async () => {
      const data = await authenticatedRequest<{
        adminHandbookStructure: StructureResult;
      }>(ADMIN_HANDBOOK_STRUCTURE);
      return data.adminHandbookStructure;
    },
  });
}

export function useUpdateStructure() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (input: UpdateStructureInput) => {
      const data = await authenticatedRequest<{
        adminUpdateHandbookStructure: StructureMutationResult;
      }>(ADMIN_UPDATE_HANDBOOK_STRUCTURE, { input });
      return data.adminUpdateHandbookStructure;
    },
    onSuccess: (result) => {
      if (result.success) {
        toast.success("분류 체계를 저장했습니다");
        queryClient.invalidateQueries({ queryKey: structureKeys.all });
      } else {
        toast.error(result.message ?? "저장에 실패했습니다");
      }
    },
    onError: (err: unknown) => {
      const msg = err instanceof Error ? err.message : "저장 중 오류가 발생했습니다";
      toast.error(msg);
    },
  });
}
